import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Row } from '../../../lib/data-set/row';

import { Grid } from '../../../lib/grid';

@Component({
    selector: 'ng2-st-tbody-custom',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
  <div class="ng2-smart-action-custom" *ngFor="let action of grid.getSetting('actions.custom')">
    <a *ngIf="!action.icon" href="#" class="ng2-smart-action ng2-smart-action-custom-custom" [innerHTML]="action.title" (click)="onCustom(action, $event)">
    </a>

    <a *ngIf="action.icon" title="{{action.title}}"  href="#" class="ng2-smart-action ng2-smart-action-custom-custom" (click)="onCustom(action, $event)">
      <nb-icon icon="{{action.icon.name}}" pack="{{action.icon.pack}}"></nb-icon>
    </a>
  </div>
  `,
    standalone: false
})
export class TbodyCustomComponent {
  @Input() grid: Grid;
  @Input() row: Row;
  @Input() source: any;
  @Output() custom = new EventEmitter<any>();

  onCustom(action: any, event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.custom.emit({
      action: action.name,
      data: this.row.getData(),
      // source: this.source,
    });
  }
}
